import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaLock, FaExternalLinkAlt } from 'react-icons/fa';
import './AreaCliente.css';

const AreaCliente = () => {
  const servicos = [
    {
      id: 1,
      nome: 'PulmoScan SaaS',
      descricao: 'Plataforma centralizada de gestão da solução PulmoScan. Gerencie pacientes de forma completa com ferramentas profissionais de avaliação respiratória, controle financeiro e análise detalhada de dados.',
      features: [
        'Gestão completa de pacientes e profissionais',
        'Avaliação respiratória com PulmoGame integrado',
        'Controle financeiro e faturamento',
        'Relatórios e análises detalhadas',
        'Histórico completo de sessões e evolução',
        'Dashboard executivo com métricas'
      ],
      url: 'https://pulmoscan.bientech.com.br/login',
      disponivel: true,
      destaque: true
    },
    {
      id: 2,
      nome: 'PulmoFlow SaaS',
      descricao: 'Plataforma integrada para profissionais e pacientes. Analise dados de Peak Flow coletados via app, gerencie agendamentos, receitas e mantenha comunicação através do chat interno.',
      features: [
        'Análise de dados de Peak Flow em tempo real',
        'Gestão financeira e controle de pagamentos',
        'Agendamento de coletas e consultas',
        'Prescrição e gestão de receitas',
        'Chat interno profissional-paciente',
        'Relatórios personalizados e tendências'
      ],
      url: 'https://pulmoflow.bientech.com.br/login',
      disponivel: true,
      destaque: false,
      beta: true
    }
  ];

  const handleCardClick = (servico) => {
    if (servico.disponivel) {
      window.open(servico.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="area-cliente-page">
      <section className="area-cliente-hero">
        <Container>
          <div className="hero-icon">
            <FaLock />
          </div>
          <h1>Área do Cliente</h1>
          <p>Acesse nossos serviços e plataformas</p>
          <p className="hero-subtitle">Escolha o serviço que deseja acessar para fazer login e começar a usar nossas soluções profissionais.</p>
        </Container>
      </section>

      <Container className="area-cliente-content">
        <Row className="services-grid justify-content-center">
          {servicos.map((servico) => (
            <Col key={servico.id} xs={12} md={10} lg={5} className="service-col">
              <Card 
                className={`service-card ${servico.destaque ? 'featured' : ''} ${!servico.disponivel ? 'disabled' : ''}`}
                onClick={() => handleCardClick(servico)}
                style={{ cursor: servico.disponivel ? 'pointer' : 'not-allowed' }}
              >
                {servico.destaque && (
                  <div className="featured-badge">
                    Acesso Disponível
                  </div>
                )}
                {servico.beta && (
                  <div className="beta-badge">
                    Versão Beta
                  </div>
                )}
                {!servico.disponivel && (
                  <div className="dev-badge">
                    Em Desenvolvimento
                  </div>
                )}
                
                <Card.Body>
                  <div className="service-header">
                    <h3 className="service-title">{servico.nome}</h3>
                    {servico.disponivel && (
                      <FaExternalLinkAlt className="external-icon" />
                    )}
                  </div>
                  
                  <p className="service-description">{servico.descricao}</p>
                  
                  <ul className="service-features">
                    {servico.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>

                  <div className="service-footer">
                    {servico.disponivel ? (
                      <button className="access-button">
                        <FaLock />
                        Fazer Login
                      </button>
                    ) : (
                      <button className="access-button disabled" disabled>
                        Em Breve
                      </button>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="help-section">
          <h3>Precisa de Ajuda?</h3>
          <p>
            Se você não tem acesso ou esqueceu sua senha, entre em contato conosco através do email{' '}
            <a href="mailto:contato@bientech.com.br">contato@bientech.com.br</a>.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default AreaCliente;
